import api, { getData } from '@/axiosConfig'
import moment from 'moment'
// eslint-disable-next-line no-unused-vars
import _ from 'lodash'
import { status, orderStates, dummyTrending } from '../../helpers'
const gemnoteAPI = api()
import i18n from '../../internatinalization/i18n'

import {
  LOAD_BAR_CHART,
  SET_COUNT_GIFTS_SENT,
  SET_HISTORICAL_ORDERS_SENT_OBJECT,
  RESET_REPORT_STATE,
  LOAD_TRENDING_GIFTS,
  SET_TRENDING_GIFTS,
  LOAD_SHIPMENTS_METRICS,
  SET_AVERAGE_SHIPMENTS,
  SET_REMAINING_SHIPMENTS,
  SET_SHIPMENT_CHART_DATA,
  LOAD_PRODUCTS
} from '@/state/mutationTypes'
import { SET_AVERAGE_SHIPMENT } from '../mutationTypes'

export default {
  async createReportChart({ commit, dispatch }) {
    try {
      commit(LOAD_BAR_CHART, status.LOADING)
      let apiRoute = 'team/dashboard_metrics/orders_this_year'
      let response = await gemnoteAPI.get(apiRoute)
      let { data } = response.data
      data = data.filter(order => order.attributes.state !== orderStates.UNPAID)

      let historicalOrdersSent = {
        labels: [],
        datasets: [
          {
            label: 'Gifts sent',
            pointRadius: 0,
            backgroundColor: function(context) {
              const chart = context.chart
              const { ctx, chartArea } = chart
              if (!chartArea) return null

              const gradient = ctx.createLinearGradient(
                0,
                chartArea.top,
                0,
                chartArea.bottom
              )
              gradient.addColorStop(0, '#DFDAD2')
              gradient.addColorStop(1, 'rgba(249, 253, 244, 0.52)')
              return gradient
            },
            data: [],
            fill: true,
            lineTension: 0.4,
            borderColor: '#68C67E',
            radius: 2,
            borderWidth: 2
          }
        ]
      }

      // using moment js we can define end day usually the actual day and the start day substracting 30 day from the actual day
      let endDate = moment().format('MM/DD/YYYY')
      let startDate = moment(endDate)
        .subtract(30, 'days')
        .format('MM/DD/YYYY')

      let totalCountOrders = 0
      while (startDate <= endDate) {
        data.forEach(order => {
          let orderWasSentAt = moment(order.attributes.createdAt).format(
            'MM/DD/YYYY'
          )
          if (orderWasSentAt === startDate) {
            totalCountOrders++
          }
        })
        startDate = moment(startDate)
          .add(1, 'days')
          .format('MM/DD/YYYY')
      }

      let months = [
        { month: '00', name: '' },
        { month: '01', name: 'Jan' },
        { month: '02', name: 'Feb' },
        { month: '03', name: 'Mar' },
        { month: '04', name: 'Apr' },
        { month: '05', name: 'May' },
        { month: '06', name: 'June' },
        { month: '07', name: 'July' },
        { month: '08', name: 'Aug' },
        { month: '09', name: 'Sep' },
        { month: '10', name: 'Oct' },
        { month: '11', name: 'Nov' },
        { month: '12', name: 'Dec' }
      ]

      let ordersPerMonth = 0
      months.forEach(month => {
        ordersPerMonth = 0
        historicalOrdersSent.labels.push(month.name)
        data.forEach(order => {
          let orderWasSentOnMonth = moment(order.attributes.createdAt).format(
            'MM'
          )
          if (orderWasSentOnMonth === month.month) {
            ordersPerMonth++
          }
        })
        historicalOrdersSent.datasets[0].data.push(ordersPerMonth)
      })

      commit(SET_COUNT_GIFTS_SENT, totalCountOrders)
      commit(SET_HISTORICAL_ORDERS_SENT_OBJECT, historicalOrdersSent)
      commit(LOAD_BAR_CHART, status.LOADED)
    } catch (error) {
      console.log(error)
      commit(LOAD_BAR_CHART, status.ERROR)
      commit(LOAD_PRODUCTS, status.ERROR)
      let errors = []
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: errors
            },
            { root: true }
          )
        }
      } else if (error.request) {
        errors.push(i18n.t('server.no-response'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      } else {
        errors.push(i18n.t('report.action.dashboard-report-error'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      }
    }
  },
  async avarageShipments({ commit, dispatch }) {
    try {
      commit(LOAD_SHIPMENTS_METRICS, status.LOADING)
      let response = await gemnoteAPI.get(
        'team/dashboard_metrics/orders_by_subscription_billing_cycle'
      )
      let {
        orders_by_subscription_billing_cycle: packagesShipped
      } = response.data
      commit(SET_AVERAGE_SHIPMENTS, packagesShipped)

      response = await gemnoteAPI.get('team/dashboard_metrics/remaining_orders')
      let { remaining_orders: remainingOrders } = response.data
      commit(SET_REMAINING_SHIPMENTS, remainingOrders)
      const { data } = await gemnoteAPI.get(
        'team/dashboard_metrics/average_shipments'
      )
      commit(SET_AVERAGE_SHIPMENT, data.average_shipments)
      let shipmentChartData = {
        labels: ['Shipped', 'Remaining'],
        datasets: [
          {
            data: [packagesShipped, remainingOrders],
            backgroundColor: ['#25282a', '#cfcfcf'],
            hoverBorderWidth: 0
          }
        ]
      }
      commit(SET_SHIPMENT_CHART_DATA, shipmentChartData)
    } catch (error) {
      console.log(error)
      commit(LOAD_SHIPMENTS_METRICS, status.ERROR)
      let errors = []
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: errors
            },
            { root: true }
          )
        }
      } else if (error.request) {
        errors.push(i18n.t('server.no-response'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      } else {
        errors.push(i18n.t('report.action.shipments-average-error'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      }
    }
  },
  async trendingGifts({ commit, dispatch }) {
    commit(LOAD_TRENDING_GIFTS, status.LOADING)
    try {
      const response = await gemnoteAPI.get(
        `team/dashboard_metrics/trending_gifts`
      )
      let data = getData(response)
      let trendingProducts = []
      const MAX_PRODUCTS = 8 // Change this number to the desired maximum number of products

      if (data.length) {
        let products = data
          .filter(product => product.attributes.representativeImages !== null)
          .filter(product => product.attributes.representativeImages.length)
          .map(product => {
            return {
              id: product.id,
              defaultImage: product.attributes.representativeImages[0].url,
              product: product.relationships.product.data,
              productName: product.attributes.displayName
            }
          })

        // Randomly pick up to MAX_PRODUCTS without including dummy products
        trendingProducts = products.slice(0, MAX_PRODUCTS)
      } else {
        // Include dummy products only if no real products are found
        trendingProducts = [...dummyTrending]
      }

      commit(LOAD_TRENDING_GIFTS, status.LOADED)
      commit(SET_TRENDING_GIFTS, trendingProducts)
    } catch (error) {
      console.log(error)
      commit(LOAD_TRENDING_GIFTS, status.ERROR)
      let errors = []
      if (error.response) {
        if (error.response.status === 500 || error.response.status === 404) {
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: [
                error.response.status === 500
                  ? i18n.t('server.server-error')
                  : i18n.t('server.not-found')
              ]
            },
            { root: true }
          )
        } else {
          let { errors } = error.response.data
          dispatch(
            'notification/pushNotification',
            {
              type: 'error',
              messages: errors
            },
            { root: true }
          )
        }
      } else if (error.request) {
        errors.push(i18n.t('server.no-response'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      } else {
        errors.push(i18n.t('report.action.trending-gifts-error'))
        dispatch(
          'notification/pushNotification',
          {
            type: 'error',
            messages: errors
          },
          { root: true }
        )
      }
    }
  },
  resetReportState({ commit }) {
    commit(RESET_REPORT_STATE)
  }
}
